import isWithinRange from 'date-fns/isWithinInterval';

import { EventDisplaySettings } from 'services/configuration';

/**
 * Returns value that matches a value on the justify prop on <FlexBox />
 * depending on the number of items.
 * @param {array} total - total number of items
 * @param {array} subset - number of items in a subset
 */

export const setJustifyCards = <T>(total: T[], subset: T[]) => {
  if (subset.length < 4 && total.length < 4) return 'around';
  if (subset.length < 4) return 'start';
  return 'around';
};

export const isCurrentTimeInRange = (timeRanges: string[]): boolean => {
  return timeRanges.some((range) => {
    const startTime = range.split('-')[0];
    const endTime = range.split('-')[1];
    const startTimeObj = new Date(
      new Date().setHours(Number(startTime.split(':')[0]), Number(startTime.split(':')[1]), 0, 0)
    );
    const endTimeObj = new Date(
      new Date().setHours(Number(endTime.split(':')[0]), Number(endTime.split(':')[1]), 59, 999)
    );
    if (startTimeObj > endTimeObj) {
      if (new Date() > startTimeObj) {
        endTimeObj.setDate(endTimeObj.getDate() + 1);
      } else {
        startTimeObj.setDate(startTimeObj.getDate() - 1);
      }
    }
    return isWithinRange(new Date(), {
      start: startTimeObj,
      end: endTimeObj
    });
  });
};

/**
 * Gets the event properties for the specified event name
 */
export const getEventDisplaySettings = (
  eventDisplaySettingsList: EventDisplaySettings[] = [],
  name: string
): EventDisplaySettings => {
  // first search for settings for the specified name
  let eventDisplaySettings = eventDisplaySettingsList.find((eds: EventDisplaySettings) => eds.name === name);
  // if not found: search for settings for the wildcard (*)
  if (!eventDisplaySettings) {
    eventDisplaySettings = eventDisplaySettingsList.find((eds: EventDisplaySettings) => eds.name === '*');
  }

  return eventDisplaySettings || {};
};
